<template>
  <div class="useCoupon">
    <div class="box">
      <p class="title">选择您要使用的优惠卷</p>
      <div class="content">
        <ul class="list">
          <li class="item" v-for="(item, index) in couponList" :key="item.id">
            <div class="leftItem">
              <div class="top">
                <div class="left">
                  <h4>{{item.name}}</h4>
                  <p class="time">有效期至{{item.expireDate}}</p>
                </div>
                <div class="right">￥<span class="price">{{item.amount}}</span></div>
              </div>
              <div class="bottom">
                <p>新用户注册</p>
              </div>
            </div>
            <div class="rightBtn" @click="use(item.amount, item.id)"><p>立即</p><p>使用</p></div>

          </li>
        </ul>
      </div>
      <img class="icon" src="../../assets/images/courier/close.png" alt="" @click="close">
    </div>
  </div>
</template>

<script>
import {reqCoupon} from '../../api'
export default {
  data () {
    return {
      couponList: [],
      pageCount: 0,
    }
  },
  created(){
    this._reqCoupon(1, 10, 0)
  },
  methods: {
    _reqCoupon(pageIndex,pageSize=10, status) {
      reqCoupon({pageIndex, pageSize, status}).then(res => {
        if(res.code === 200) {
          this.couponList = res.data.bussData
          this.pageCount = res.data.pageCount
        }
      })
    },
    // 使用优惠券
    use(amount, couponId) {
      console.log(amount)
      this.$store.dispatch('getCouponAmount', {amount,couponId})
      this.$emit('close')
    },
    // 关闭
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.useCoupon{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  z-index: 1000;
  .box{
    position: relative;
    margin:50px auto;
    width: 667px;
    height: 700px;
    padding:40px 35px 60px;
    box-sizing: border-box;
    background: #fff;
    .title{
      margin-bottom: 25px;
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      color: #2c2c2c;
    }
    .content{
      display: flex;
      height: 575px;
      overflow-y: auto;
      .list{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item{
          display: flex;
          .leftItem{
            position: relative;
            width: 426px;
            height: 192px;
            padding:55px 53px 33px 64px;
            box-sizing: border-box;
            color:#fff;
            background: url("../../assets/images/person/youhuiquan_bg.png");
            .grey{
              position: absolute;
              top: 23px;
              left: 14px;
              transform: rotate(-37deg);
            }
            .top{
              display: flex;
              justify-content: space-between;
              .left{
                h4{
                  font-size: 24px;
                  font-weight: bold;
                  margin-bottom: 9px;
                  font-family:PingFang-SC-Bold;
                }
              }
              .right{
                font-size: 23px;
                font-weight: bold;
                .price{
                  font-size: 49px;
                }
              }
            }
            .bottom{
              position: absolute;
              bottom: 33px;
              left: 50%;
              transform: translate(-50%, 0);
              p{
                font-weight: bold;
              }
            }
          }
          .rightBtn{
            width: 137px;
            height: 168px;
            margin-top:10px;
            margin-left: 26px;
            padding: 24px 38px;
            line-height: 60px;
            box-sizing: border-box;
            border-radius: 20px;
            background: #FFC168;
            font-size: 30px;
            cursor: pointer;
          }
        }
      }
    }
    .icon{
      position: absolute;
      top: 13px;
      right: 16px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Courier/UseCoupon.vue